import PropTypes from "prop-types";

export const hasCSMWeezard = () => !!localStorage.csmweezard;

const CSMWeezard = ({ children }) => {
	if (!hasCSMWeezard()) {
		return null;
	}

	return children;
};

CSMWeezard.propTypes = {
	children: PropTypes.any
};

/**
 * @function useOptions
 * @description retrieve the status of the debug or csm option
 * @return {Object} - send the debug and csm option status
 */
export const useOptions = () => ({
	debug: Boolean(localStorage.debug),
	csm: Boolean(localStorage.csmweezard)
});

export default CSMWeezard;
